import roundMoney from './roundMoney.js'

export default (total, discount, partySize, maxPromoAmount) => {
  if (discount.discountType == 'percent') {
    return roundMoney(total * discount.percent / 100)
  } else {
    return Math.min(
      discount.fixedAmount * (partySize || 1),
      maxPromoAmount || 100000
    )
  }
}
